import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import PageState from "../../../Constants/Base/PageState";
import TablePageContext, {
    FilterDefaults,
    TableDataDefaults,
    TablePageOptionDefaults
} from "../../../Context/TablePageContext";
import {changePageSizeState} from "../../../Slices/PageSlice";
import PageSizeState from "../../../Constants/Base/PageSizeState";
import {changeBreadcrumbs} from "../../../Slices/BreadcrumbsSlice";
import Modules from "../../../Constants/Base/Modules";
import strings from "../../../localization";
import TablePage from "../../../Components/DataGrid/TablePage";
import {formatColumnObject} from "../../../Components/DataGrid/ValueFormatter";
import {deleteBankAccount, getBankAccounts} from "../../../Services/Company/BankAccountService";
import AddBankAccount from "./AddBankAccount";
import EditBankAccount from "./EditBankAccount";
import { useNavigate, useSearchParams } from "react-router-dom";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import AppPermissions from "../../../Constants/Permissions/Permissions";
import Tag from "../../../Components/Forms/Pages/Document/Tag/Tag";

const tableDescription = [

    {field: 'name', headerName: strings.pages.finance.bankAccount.bankAccountList.name, width: 200},
    {field: 'account', headerName: strings.pages.finance.bankAccount.bankAccountList.account, width: 200},
    {field: 'iban', headerName: strings.pages.finance.bankAccount.bankAccountList.iban, width: 200},
    {
        field: 'currency',
        headerName: strings.pages.finance.bankAccount.bankAccountList.currency,
        valueFormatter: (params) => formatColumnObject(params, 'code'),
        width: 200
    },
    {
        field: 'bank',
        headerName: strings.pages.finance.bankAccount.bankAccountList.bank,
        valueFormatter: (params) => formatColumnObject(params, 'name'),
        width: 200
    },
];


const filters = [];


const BankAccountList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [updatedFilter, setUpdatedFilter] = useState(!Boolean(searchParams.toString()));
    const [columns, setColumns] = useState([]);
    const [pageState, setPageState] = useState(PageState.View);
    const [filter, setFilter] = useState(FilterDefaults);
    const [tableData, setTableData] = useState(TableDataDefaults);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedItems, setSelectedItems] = useState(null);
    const [tablePageOptions, setTablePageOptions] = useState(TablePageOptionDefaults);
    const referenceType = ReferenceType.BANK_ACCOUNT;
    const permissionGroup = AppPermissions.BANK_ACCOUNT.GROUP;

    const value = {
        tablePageOptions, setTablePageOptions,
        selectionModel, setSelectionModel,
        selectedItems, setSelectedItems,
        filter, setFilter, pageState, setPageState, showDeleteDialog, setShowDeleteDialog,
        navigate, updatedFilter, setUpdatedFilter
    }

    useEffect(() => {

        setColumns([...tableDescription]);
        dispatch(changePageSizeState(PageSizeState.SHORT));
        dispatch(changeBreadcrumbs({
            title: strings.pages.finance.settings.bankAccounts,
            hierarchy:[
                {label: strings.navigation.managmentTag},
                {label: Modules.FINANCE},
                {label: strings.pages.finance.settings.settings},
                {label: strings.pages.finance.settings.bankAccounts},
            ],        
        }));

        return () => {
            setTableData({})
        }
    }, [])

    useEffect(() => {
        if(!updatedFilter){
            return;
        }

        fetch();
    }, [filter, updatedFilter])

    const onCancel = () => {
        setPageState(PageState.View);
    }

    const onFinish = () => {
        fetch();
        setPageState(PageState.View);
    }

    const fetch = () => {
        setTableData({
            ...tableData,
            loading: true
        });

        getBankAccounts({
            ...filter
        }).then(response => {

            if (!response || !response.ok) {
                return;
            }

            setTableData({
                loading: false,
                data: response.data.result,
                total: response.data.total
            });
        })
    }

    return <TablePageContext.Provider value={value}>

        <TablePage onFinish={() => onFinish()} tableDescription={columns} deleteItem={deleteBankAccount}
                   tableData={tableData} 
                   filter={filter} filters={filters}
                   permissionGroup={permissionGroup}
                   referenceType={referenceType}
                   onCancel={() => onCancel()}
                   tagPage={<Tag referenceType={ referenceType } data={ selectedItems } /> }
                   editPage={<EditBankAccount data={selectedItems} onFinish={() => onFinish()}
                                              onCancel={() => onCancel()}/>}
                   addPage={<AddBankAccount onCancel={() => onCancel()} onFinish={() => onFinish()}/>
                }
                hideBreadcrumbs
                addButtonText={strings.components.tablePage.addButton.bankAccount}
        />
    </TablePageContext.Provider>;
}

export default BankAccountList;
